import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { TViewMode } from "./view-mode-types";
import { DekoxIcon, MuiIcon } from "../deko-x-icons";
import { useGenericTranslationsT } from "src/translation-hooks/generic-translations";
import { Tooltip } from "@itk/mui-components";

type Props = {
  value: TViewMode;
  onChange: (value: TViewMode) => void;
};

export const ViewMode = ({ onChange, value }: Props) => {
  const genericTranslationsT = useGenericTranslationsT();

  return (
    <ToggleButtonGroup
      size="small"
      value={value}
      exclusive
      onChange={(_, value) => {
        onChange(value);
      }}
    >
      {(["FULL", "MINIMAL"] as TViewMode[]).map(value => {
        let icon: MuiIcon = "expand";
        let tooltipTitle = "";

        switch (value) {
          case "FULL":
            tooltipTitle = genericTranslationsT.fullView;
            icon = "fullScreen";
            break;
          case "MINIMAL":
            tooltipTitle = genericTranslationsT.minimalView;
            icon = "fullScreenExit";
        }
        return (
          <ToggleButton value={value} key={value}>
            <Tooltip title={tooltipTitle}>
              <DekoxIcon icon={icon} fontSize="small" />
            </Tooltip>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};
